import { render, staticRenderFns } from "./KeywordList.vue?vue&type=template&id=4f34f8c4&scoped=true&"
import script from "./KeywordList.vue?vue&type=script&lang=js&"
export * from "./KeywordList.vue?vue&type=script&lang=js&"
import style0 from "./KeywordList.vue?vue&type=style&index=0&id=4f34f8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34f8c4",
  null
  
)

export default component.exports